// Project kickoff in a Meet room (KB "SOPs/Project Kickoff Meeting"). The owner gives a brief and an agenda; Pioneer
// summarises it, each agent says what it would take, what it needs and its main risk, and Pioneer reads a recap.
// The recap goes to the clipboard for the scribe to turn into Office tickets.
// ponytail: no Office posting from Meet yet; the owner pastes the recap into #proj-<name>.
import type { Session } from "./api";
import { HOST, Stage } from "./heads";
import { openRoom, type Note } from "./standup";
import { kickoffPrompt, parseKickoff, recap } from "./kickoff-text";

export const KICKOFF_AGENDA = ["aurelian", "soren", "guilliman"];

export async function runKickoff(meeting: string, peerId: string, session: Session, stage: Stage, status: (text: string) => void,
	{ title, brief, agenda }: { title: string; brief: string; agenda: string[] }) {
	const { agents, say, ask, ready } = await openRoom(meeting, peerId, session, stage, agenda, "kickoff");
	status("Loading faces…");
	await ready();
	status("Kickoff running");
	const gist = brief.replace(/^#.*$/gm, "").replace(/\s+/g, " ").trim().split(/(?<=[.!?])\s/).slice(0, 2).join(" ");
	await say(HOST, `This is the kickoff for ${title}. ${gist} ${agents.map((a) => a.name).join(", ")}: what you would take, what you need, and your biggest risk.`, "smile");
	const notes: Note[] = [];
	for (const a of agents) {
		await say(HOST, `${a.name}, you are up.`);
		status(`Waiting for ${a.name}…`);
		const note = await ask(a, kickoffPrompt(title, brief));
		notes.push(note);
		status("Kickoff running");
		if (note.reply) await say(a.slug, note.reply);
		else await say(HOST, `${a.name} did not answer: ${note.error!.replace(/[.\s]+$/, "")}. Moving on.`, "concerned");
	}
	const pieces = notes.reduce((n, x) => n + (x.reply ? parseKickoff(x.reply).take.length : 0), 0);
	await say(HOST, `That is the kickoff. ${pieces} pieces proposed across ${notes.filter((n) => n.reply).length} agents. The recap goes to the scribe for tickets.`, "smile");
	const text = recap(title, notes);
	await navigator.clipboard.writeText(text).catch(() => {});
	status("Kickoff done · recap copied");
	return text;
}
